import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {ObservablesService} from '../observables.service'
import { Subject } from "rxjs";
import { _ } from 'underscore';
import {ApiService} from '../api.service'
import {PrintService} from '../print.service'
@Component({
  selector: 'app-invoice-print',
  templateUrl: './invoice-print.component.html',
  styleUrls: ['./invoice-print.component.scss']
})
export class InvoicePrintComponent implements OnInit {
  invoiceIds: string[];
  invoiceDetails: Promise<any>[];
  invoiceViewSubscriber:any;
  slipSubscribeVariable:any;
  slipObserver:any = new Subject<any>();
  productSubscribeVariable:any;
  productObserver:any = new Subject<any>();
  loggedUserInfo:any;
  invoiceData:any;
  itemData:any=[];
  gstAmount:number = 0;
  totalAmt:number = 0;
  totalWeight:number = 0;
  sameStateStatus:boolean = true;
  preferences:any=[];
  slipData:any= [];
  variableSubscribeVariable:any;
  variableObserver:any = new Subject<any>();
  direct_invoice_items:any=[]
  direct_slip_items:any=[]
  constructor(private print:PrintService, route: ActivatedRoute,private api:ApiService,private observables:ObservablesService) {
    this.invoiceIds = route.snapshot.params['invoiceIds']
      .split(',');
   }

  ngOnInit() {
    this.api.getLoggedUserInfo().then((res:any)=>{
      // console.log('logged user info=',res)
      if(res.data.length > 0){
        this.loggedUserInfo = res.data[0];
        this.getPreferences()
        // console.log('id==',this.invoiceIds)
        this.invoiceDetails = this.invoiceIds
            .map(id => this.getInvoiceDetails(id));
            Promise.all(this.invoiceDetails)
            .then(() => this.print.onDataReady());
      }
    })
  }

  getPreferences(){
    this.api.send("findDb",{
      table:"preferences",
      conditions:[{"business_id":this.loggedUserInfo.business_id}]
    }).then((res:any)=>{
      if(res.data.length > 0){
        this.preferences = res.data[0]
        // console.log("preferences==",this.preferences)
      }else{
        //create a preference
      }
    })
  }

  getInvoiceDetails(invoice_id){
    return new Promise((resolve)=>{

      this.api.send("findDb",{
        fields:["I.*,P.*,I.id,I.party_name as busi_name"],
        table:"master_invoices as I",
        joins:[{
          type:"left",
          table:"parties as P",
          conditions:["P.id = I.party_id"]
        }],
        conditions:[{
          "I.id" :invoice_id
        }]
      }).then((result:any)=>{
        if(result.data.length > 0){

          this.invoiceData = result.data[0];
          this.checkState();

          if(this.invoiceData.direct_invoice_status){

              this.totalAmt =this.totalAmt + this.invoiceData.total_amount;
              if(this.invoiceData.slip_status){
                this.direct_invoice_items= []
                this.getSlipDetails(this.invoiceData.id).then((abc)=>{
                  resolve({status:true})
                })
              }else{
                this.direct_slip_items = []
                this.direct_invoice_items.push(this.invoiceData)
                resolve({status:true})
              }
          }else{

            if(this.invoiceData.slip_status){

              this.getSlipDetails(this.invoiceData.id).then((resp)=>{
                 resolve({status:true})
              })
            }else{

              this.getCategoriess().then((resp)=>{
                resolve({status:true})
              })

            }
          }
          // setTimeout(() => resolve({status:true}), 1000)

        }else{
          resolve({status:false})
        }
      })
    })
  }

  getCategoriess(){
    // console.log("this.invoiceData=",this.invoiceData)
    return new Promise((resolve)=>{

      this.api.send("findDb",{
        table:"categories",
        conditions:[{invoice_id:this.invoiceData.invoice_id}]
      }).then((result1:any)=>{
        // console.log("category == ",result1.data)
        this.getInvoiceData(result1.data).then((res:any)=>{

          // console.log("final data = ",res)
          this.itemData = res;
          // this.getWeightTotal()
          this.getGstAmount().then(()=>{
            resolve(true)
          })

          // //this.getTotalAmt()
        })

      })
    })
  }
getInvoiceData(data){
    // console.log("abcd==",data)
    return new Promise((resolve)=>{
      let a = 0
      let number = 0
      this.productSubscribeVariable = this.productObserver.subscribe((a)=>{
        if(a>=data.length){
          this.productSubscribeVariable.unsubscribe();
          resolve(data)
        }else{
          if(data[a].hasOwnProperty('category_name')){
            this.api.send("findDb",{
              table:"master_invoice_products as PD",
              joins:[{
                type:"left",
                table:"product_details as P",
                conditions:["P.id = PD.product_detail_id"]
              }],
              conditions:[{
                "PD.master_invoice_id" :this.invoiceData.id,
                "PD.category_id":data[a].id
              }],
              order:"PD.id ASC"
            }).then((result2:any)=>{
              // console.log("product data=",result2.data)
              if(result2.data.length > 0){
                this.prepareData(result2.data,a,data,number).then((resp:any)=>{
                  data=resp.data;
                  number=resp.number
                  this.productObserver.next(data.length+1);
                })

              }else{
                this.productObserver.next(a+1);
              }
            })
          }else{
            this.productObserver.next(a+1);
          }

        }
      })

      this.productObserver.next(a);
    })
  }

  getTotalSqmt(item){
    if (!item || !item.col_1_value || !item.col_2_value) return 0;
    return parseFloat(((item.col_1_value * item.col_2_value) * 0.000001).toFixed(2));
  }

  qtyLabelColspan(){
    let cols = 3;
    if(this.preferences.unit_variable_1_status) cols++;
    if(this.preferences.unit_variable_2_status) cols++;
    if(this.preferences.unit_variable_3_status) cols++;
    if(this.preferences.item_unit_col_name_status) cols++;
    return cols;
  }

  qtyTrailingColspan(){
    let cols = 1;
    if(this.preferences.unit_price_status) cols++;
    if(this.preferences.discount_status) cols++;
    if(this.preferences.tax_status) cols++;
    return cols;
  }

  getTotalQty() {
    return Number(
      this.itemData
        .reduce((acc: number, item: any) => {
          return acc + (parseFloat(item.qty) || 0);
        }, 0)
        .toFixed(2)
    );
  }


  getTotalSqmtTotal() {
    const total = Number(
      this.itemData
        .reduce((acc: number, item: any) => {
          const h = Number(item.col_1_value || 0);
          const w = Number(item.col_2_value || 0);
  
          return acc + (h * w * 0.000001);
        }, 0)
        .toFixed(2)
    );
  
    return total;
  }

  checkState(){
    if(this.invoiceData && this.invoiceData.gstin && this.invoiceData.gstin.length > 0){
      // console.log("1",this.invoiceData);
      // console.log("2",this.invoiceData);
      if(this.loggedUserInfo.gstin.substring(0,2) == this.invoiceData.gstin.substring(0,2)){
        this.sameStateStatus = true;
      }else{
        this.sameStateStatus = false;
      }
    }else{
      this.sameStateStatus = true;
    }
  }

  getTotalUnit(variables){
    // console.log("asdasd=",variables)
    if(variables !== undefined){

      return variables.reduce( ( accumulator, currentValue ) => {
        return accumulator * parseFloat(currentValue.unit_variable_value);
      }, 1);
    }
  }

  round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  }


  getSlipDetails(invoice_id){
    return new Promise((resolve)=>{
      this.direct_slip_items =[]
      this.api.send("findDb",{
        fields:["S.*,P.*,S.id as master_slip_id,S.party_name as business_name"],
        table:"master_slips as S",
        joins:[{
          type:"left",
          table:"parties as P",
          conditions:["P.id = S.party_id"]
        }],
        conditions:[{
          "S.master_invoice_id" :invoice_id
        }]
      }).then((result:any)=>{
        if(result.data.length > 0){

          this.slipData = result.data;
          // console.log("this.slipdata==",this.slipData)
          if(!this.invoiceData.direct_invoice_status){

            this.getCategories(true).then((res:any)=>{
              resolve(true)
            })
          }else{
            this.direct_slip_items = this.slipData
            resolve(true)
          }
        }else{
          resolve(false)
        }
      })
    })
  }
  // getSlipDetails(invoice_id){
  //
  //   this.api.send("findDb",{
  //     fields:["S.*,P.*,S.id as slip_id"],
  //     table:"slips as S",
  //     joins:[{
  //       type:"left",
  //       table:"parties as P",
  //       conditions:["P.id = S.party_id"]
  //     }],
  //     conditions:[{
  //       "S.invoice_id" :invoice_id
  //     }]
  //   }).then((result:any)=>{
  //     if(result.data.length > 0){
  //
  //       this.slipData = result.data[0];
  //       // console.log("this.slipdata==",this.slipData)
  //        this.getCategories(true)
  //      }
  //   })
  // }

  // getCategories(slipStatus){
  //   let conditions:any = (slipStatus)?{slip_id:this.slipData.slip_id}:{invoice_id:this.invoiceData.id}
  //   this.api.send("findDb",{
  //     table:"categories",
  //     conditions:[conditions]
  //   }).then((result1:any)=>{
  //     // console.log("category == ",result1.data)
  //     this.getData(result1.data).then((res:any)=>{
  //
  //       // console.log("final data = ",res)
  //       this.itemData = res;
  //       // this.getWeightTotal()
  //       this.getGstAmount()
  //       // //this.getTotalAmt()
  //     })
  //
  //   })
  // }

  getCategories(slipStatus){
    return new Promise((resolve)=>{
      let a = 0
      let number = 0
      // console.log("slipDatass== ",this.slipData)
      this.slipSubscribeVariable = this.slipObserver.subscribe((a)=>{
        if(a>=this.slipData.length){
          this.slipSubscribeVariable.unsubscribe();
          this.getGstAmount().then(()=>{

            resolve(this.slipData)
          })
        }else{
          let conditions:any = (slipStatus)?{slip_id:this.slipData[a].slip_id}:{invoice_id:this.invoiceData.id}
          this.api.send("findDb",{
            table:"categories",
            conditions:[conditions]
          }).then((result1:any)=>{
            // console.log("category == ",result1.data)

            this.getData(result1.data,a).then((res:any)=>{

              // console.log("final data = ",res)
              this.processData(res).then((resp)=>{

                // console.log("final datasa = ",resp)
                this.slipObserver.next(a+1);
              })
              // this.getWeightTotal()

              // //this.getTotalAmt()
            })

          })


        }
      })

      this.slipObserver.next(a);
    })
  }

  processData(res){
    return new Promise((resolve)=>{

      for(let i=0;i<res.length;i++){

        this.itemData.push(res[i]);

        if(i == res.length - 1){
          resolve(true)
        }
      }
    })
  }

  getData(data,index){
    return new Promise((resolve)=>{
      let a = 0
      let number = 0
      this.productSubscribeVariable = this.productObserver.subscribe((a)=>{
        if(a>=data.length){
          this.productSubscribeVariable.unsubscribe();
          resolve(data)
        }else{
          if(data[a].hasOwnProperty('category_name')){

            this.api.send("findDb",{
              table:"master_slip_products as PD",
              conditions:[{
                "PD.master_slip_id" :this.slipData[index].master_slip_id,
                "PD.category_id":data[a].id
              }],
              order:"PD.id ASC"
            }).then((result2:any)=>{
              // console.log("product data=",result2.data)
              if(result2.data.length > 0){
                this.prepareData(result2.data,a,data,number).then((resp:any)=>{
                  data=resp.data;
                  number=resp.number
                  this.productObserver.next(a+1);
                })

              }else{
                this.productObserver.next(a+1);
              }
            })
          }else{
            this.productObserver.next(a+1);
          }

        }
      })

      this.productObserver.next(a);
    })
  }

  // getData(data,slip_status){
  //   return new Promise((resolve)=>{
  //     let a = 0
  //     let number = 0
  //     this.productSubscribeVariable = this.productObserver.subscribe((a)=>{
  //       if(a>=data.length){
  //         this.productSubscribeVariable.unsubscribe();
  //         resolve(data)
  //       }else{
  //         if(data[a].hasOwnProperty('category_name')){
  //
  //           this.api.send("findDb",{
  //             fields:["PD.rate as product_rate,PD.*,PD.id as product_detail_id,I.name as item_name,I.gst,U.name as unit_name,I.discount"],
  //             table:"product_details as PD",
  //             joins:[{
  //               type:"left",
  //               table:"items as I",
  //               conditions:["I.id = PD.item_id"]
  //             },{
  //               type:"left",
  //               table:"units as U",
  //               conditions:["U.id = I.unit_id"]
  //             }],
  //             conditions:[{
  //               "PD.invoice_id" :this.invoiceData.id,
  //               "PD.category_id":data[a].id
  //             }],
  //             order:"PD.id ASC"
  //           }).then((result2:any)=>{
  //             // console.log("product data=",result2.data)
  //             if(result2.data.length > 0){
  //               this.prepareData(result2.data,a,data,number).then((resp:any)=>{
  //                 data=resp.data;
  //                 number=resp.number
  //                 this.productObserver.next(a+1);
  //               })
  //
  //             }else{
  //               this.productObserver.next(a+1);
  //             }
  //           })
  //         }else{
  //           this.productObserver.next(a+1);
  //         }
  //
  //       }
  //     })
  //
  //     this.productObserver.next(a);
  //   })
  // }
  prepareData(item,index,data,number){
    return new Promise((resolve)=>{
      let a = 1
      this.variableSubscribeVariable = this.variableObserver.subscribe((a)=>{
        if(a>item.length){
          this.variableSubscribeVariable.unsubscribe();
          resolve({data:data,number:number})
        }else{
          number = number + 1;
          data.splice(index+a, 0, item[a-1]);
          data[index+a].number = number;
          // data[index+a].unit_variables = []
          //   this.getProductUnitVariables(item[a-1]).then((itemRes:any)=>{
          //     data[index+a].unit_variables = itemRes
                this.variableObserver.next(a+1);

            // })
        }

      })

      this.variableObserver.next(a);
    })
  }

  getProductUnitVariables(item){
    return new Promise((resolve)=>{
      this.api.send("findDb",{
        table:"product_unit_variables as PU",
        joins:[{
          type:"left",
          table:"unit_variables as UV",
          conditions:["UV.id = PU.unit_variable_id"]
        }],
        conditions:[{"PU.product_detail_id":item.product_detail_id}]
      }).then((res:any)=>{
        if(res.data.length > 0){

          resolve(res.data)
        }
      })
    })
  }


  async getGstAmount(){

    await this.itemData.filter((item:any)=>{
      if(item.hasOwnProperty('item_id')){
        this.gstAmount=this.gstAmount + ((item.gross_amount*item.gst)/100);
        this.totalAmt=this.totalAmt + item.gross_amount;
      }
    })

  }

}
